import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = {
  loanType: null,
  totalDeductions: 0,
  totalDeductionsTabLoadingActive: true,
  gridRows: [],
  chequeModes: ["AUTO", "MANUAL"],
  chequePrintAt: [],
  bankAccountTypes: ["CURRENT", "SAVINGS"],
  currentRowPaymentMode: null,
  currentGridPaymentModes: [],
  currentRowChequeMode: null,
  currentRowChequePrintAt: [],
  screenMode: "",
  bankAccountNums: [],
  customerBankDetails: [],
  bankNamesWithCodes: [],
  currentRowIfscCodes: [],
  shflbankBranches: {},
  currentRowShflBankBranches: [],
  disbursementLovData: {
    targetFields: [],
    lovDataValue: {},
  },
  deleteOperationActive: false,
  gridAreaSkeletonLoading: true,
  isGridRecordsValid: true,
  validGridRecordsAsNonEditable: [],
  activePageNumber: 0,
  chequeHandOverOrAuthorizeDlgData: {
    dlgOpen: false,
    dlgMode: "",
    dlgModeLabel: "",
    dlgGridRows: [],
    spinnerFlag: false,
    spinnerText: "",
  },
  chequeHandOverUploadAreaOpen: false,
};
const DisbursementBalanceTransferReducer = createSlice({
  name: "disbursementBalanceTransfer",
  initialState: initialStateValue,
  reducers: {
    updateTotalDeductions(state, action) {
      state.totalDeductions = action.payload;
    },
    updateTotalDeductionsTabLoadingActive(state, action) {
      state.totalDeductionsTabLoadingActive = action.payload;
    },
    updateChequeHandOverSpinnerFlag(state, action) {
      state.chequeHandOverOrAuthorizeDlgData.spinnerFlag = action.payload;
    },
    updateChequeHandOverSpinnerText(state, action) {
      state.chequeHandOverOrAuthorizeDlgData.spinnerText = action.payload;
    },
    updateChequeHandOverUploadAreaOpen(state, action) {
      state.chequeHandOverUploadAreaOpen = action.payload;
    },
    updateChequeHandOverAllocationOrAuthorizationGridRows(state, action) {
      state.chequeHandOverOrAuthorizeDlgData.dlgGridRows = action.payload;
    },
    updateChequeHandOverOrAuthorizeDlgData(state, action) {
      state.chequeHandOverOrAuthorizeDlgData.dlgOpen = action.payload.dlgOpen;
      state.chequeHandOverOrAuthorizeDlgData.dlgMode = action.payload.dlgMode;
      state.chequeHandOverOrAuthorizeDlgData.dlgModeLabel =
        action.payload.dlgModeLabel;
      state.chequeHandOverOrAuthorizeDlgData.spinnerFlag =
        action.payload.spinnerFlag;
      state.chequeHandOverOrAuthorizeDlgData.spinnerText =
        action.payload.spinnerText;
    },
    updateActivePageNumber(state, action) {
      state.activePageNumber = action.payload;
    },
    updateValidGridRecordsAsNonEditable(state, action) {
      state.validGridRecordsAsNonEditable = action.payload;
    },
    updateIsGridRecordsValid(state, action) {
      state.isGridRecordsValid = action.payload;
    },
    updateGridAreaSkeletonLoading(state, action) {
      state.gridAreaSkeletonLoading = action.payload;
    },
    updateDeleteOperationActive(state, action) {
      // spinner load for the balance transfer.
      state.deleteOperationActive = action.payload;
    },
    updateLovTargetFields(state, action) {
      state.disbursementLovData.targetFields = action.payload;
    },
    updateLovDataValue(state, action) {
      state.disbursementLovData.lovDataValue = action.payload;
    },
    resetToInitialState(state, action) {
      state = { ...initialStateValue };
    },
    updateChequePrintAtArray(state, action) {
      state.chequePrintAt = action.payload;
    },
    updateCustomerBankDetails(state, action) {
      state.customerBankDetails = action.payload;
    },
    updateBankAccountNums(state, action) {
      state.bankAccountNums = action.payload;
    },
    updateBankNamesWithCodes(state, action) {
      state.bankNamesWithCodes = action.payload;
    },
    updateCurrentRowIfscCodes(state, action) {
      state.currentRowIfscCodes = action.payload;
    },
    updateCurrentRowShflBankBranches(state, action) {
      state.currentRowShflBankBranches = action.payload;
    },
    updateShflBankBranches(state, action) {
      state.shflbankBranches = action.payload;
    },
    updateScreenMode(state, action) {
      state.screenMode = action.payload;
    },
    updateLoanType(state, action) {
      state.loanType = action.payload;
    },
    updateGridRows(state, action) {
      state.gridRows = action.payload;
    },
    resetGridRows(state, action) {
      state.gridRows = [];
      // on every row click current row ifsc codes will load.
      // on reset the grid reset the below values also.
      state.currentRowIfscCodes = [];
      state.bankNamesWithCodes = [];
      state.currentRowShflBankBranches = [];
      state.shflbankBranches = initialStateValue.shflbankBranches;
      state.validGridRecordsAsNonEditable = [];
      state.activePageNumber = 0;
    },
    updateCurrentRowPaymentMode(state, action) {
      state.currentRowPaymentMode = action.payload;
    },
    updateCurrentGridPaymentModes(state, action) {
      state.currentGridPaymentModes = action.payload;
    },
    updateCurrentRowChequeMode(state, action) {
      state.currentRowChequeMode = action.payload;
    },
    updateCurrentRowChequePrintAtValues(state, action) {
      state.currentRowChequePrintAt = action.payload;
    },
  },
});
export const DisbursementBalanceTransferReducerAction =
  DisbursementBalanceTransferReducer.actions;
export default DisbursementBalanceTransferReducer.reducer;
